/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Whatever you type — a word, a line, or several lines — is repeated as a block each time.`)
};

const es_tr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Lo que sea que escribas — una palabra, una línea, o varias líneas — se repite como un bloque cada vez.`)
};

const de_tr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Was auch immer Sie eingeben — ein Wort, eine Zeile oder mehrere Zeilen — wird jedes Mal als Block wiederholt.`)
};

const nl_tr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Wat je typt - een woord, een regel of meerdere regels - wordt elke keer als een blok herhaald.`)
};

const fr_tr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Tout ce que vous tapez — un mot, une ligne ou plusieurs lignes — est répété comme un bloc à chaque fois.`)
};

const it_tr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Qualunque cosa tu digiti — una parola, una riga, o più righe — viene ripetuta come un blocco ogni volta.`)
};

const pt_br2_tr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. O que quer que você digite — uma palavra, uma linha ou várias linhas — é repetido como um bloco cada vez.`)
};

const pt_tr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. O que quer que escreva — uma palavra, uma linha ou várias linhas — é repetido como um bloco cada vez.`)
};

const ja_tr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。入力するもの（単語、行、または複数行）は、毎回ブロックとして繰り返されます。`)
};

const zh_tr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。无论你输入的是一个单词、一行还是多行内容，都会作为一个整体块每次重复。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tr_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tr_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tr_faq2_a", locale)
	if (locale === "en") return en_tr_faq2_a(inputs)
	if (locale === "es") return es_tr_faq2_a(inputs)
	if (locale === "de") return de_tr_faq2_a(inputs)
	if (locale === "nl") return nl_tr_faq2_a(inputs)
	if (locale === "fr") return fr_tr_faq2_a(inputs)
	if (locale === "it") return it_tr_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_tr_faq2_a(inputs)
	if (locale === "pt") return pt_tr_faq2_a(inputs)
	if (locale === "ja") return ja_tr_faq2_a(inputs)
	return zh_tr_faq2_a(inputs)
};